exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disableTip[data-v-5d8b50f2]{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}section[data-v-5d8b50f2]{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:60px 30px;font-size:16px;line-height:1.8}p[data-v-5d8b50f2]{text-indent:2em}", ""]);

// exports
